import React, { useState, useEffect, useCallback } from "react";
import { useLocation, useHistory, Redirect } from "react-router-dom";
import { connect, useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import AssessmentFormTypes from "./AssessmentFormTypes";
import AssessmentFormBody from "./AssessmentFormBody";
import {
  addAssessment,
  importAssessments,
  updateAssessment,
  clearAssessment,
  clearResultList,
  deleteAssessment,
  getAssessmentInstructionByCategoryID,
  clearAssessmentGroup,
  deleteMultipleAssessments,
  loadAssessmentsList,
} from "../../../actions/admin";
import AssessmentFormSchools from "./AssessmentFormSchools";
import { useDropzone } from "react-dropzone";
import {
  ASSESSMENT_TYPE_OPTIONS,
  ALL_LEVEL_OPTIONS,
} from "../../../utils/assessmentToLevelMapping";
import exceptionRules from "../../../utils/exceptionRules.json";
import exceptionRulesPM from "../../../utils/exceptionRulesPM.json";
import MultiSelectWithCheckboxes from "../../layouts/MultiSelect";
import { setAlert } from "../../../actions/alerts";
import Alert from "../../layouts/Alert";
import Loading from "../../layouts/Loading";

const LoadBodyItems = (data) => {
  let arr = [];
  let TotalWord = 0;

  if (data === null) return "";
  else if (data.Body === undefined) {
    return "";
  } else if (data.Solution === undefined) {
    return data.Body;
  }

  if (data.SolutionDetails !== null) {
    const Body = data.Body.split(",");
    const Solution = data.Solution.split(",");
    const SolutionDetails = data.SolutionDetails.split(",");
    const Scores = data.Scores.split(",");

    TotalWord = Body.length;

    for (let i = 0; i < Body.length; i++) {
      arr.push({
        Word: Body[i],
        Solution: Solution[i],
        SolutionDetails: SolutionDetails[i],
        Scores: Scores[i],
      });
    }
  } else {
    const Body = data.Body.split(",");
    const Solution = data.Solution.split(",");
    const Scores = data.Scores.split(",");

    TotalWord = Body.length;

    for (let i = 0; i < Body.length; i++) {
      arr.push({
        Word: Body[i],
        Solution: Solution[i],
        SolutionDetails: "",
        Scores: Scores[i],
      });
    }
  }

  return arr;
};

// const countWords = (text) => {
//   const words = text.trim().split(/\s+/);
//   return words.filter((word) => word !== "").length;
// };
const countWords = (text) => {
  const words = text
    .replace(/&nbsp;/g, " ")
    .trim()
    .split(/\s+/);

  return words.filter(Boolean).length;
};

const probeOptions = [
  { value: 1, label: "Probe 1" },
  { value: 2, label: "Probe 2" },
  { value: 3, label: "Probe 3" },
  { value: 4, label: "Probe 4" },
  { value: 5, label: "Probe 5" },
  { value: 6, label: "Probe 6" },
  { value: 7, label: "Probe 7" },
  { value: 8, label: "Probe 8" },
  { value: 9, label: "Probe 9" },
  { value: 10, label: "Probe 10" },
  { value: 11, label: "Probe 11" },
  { value: 12, label: "Probe 12" },
  { value: 13, label: "Probe 13" },
  { value: 14, label: "Probe 14" },
  { value: 15, label: "Probe 15" },
  { value: 16, label: "Probe 16" },
  { value: 17, label: "Probe 17" },
  { value: 18, label: "Probe 18" },
  { value: 19, label: "Probe 19" },
  { value: 20, label: "Probe 20" },
];

const gradeIdToLabel = (gradeID) => {
  switch (parseInt(gradeID)) {
    case 7:
      return "Kindergarten";
    case 1:
      return "Grade 1";
    case 2:
      return "Grade 2";
    case 3:
      return "Grade 3";
    case 4:
      return "Grade 4";
    case 5:
      return "Grade 5";
    case 6:
      return "Grade 6";
    case 8:
      return "Grade 7";
    case 9:
      return "Grade 8";
    case 10:
      return "Other";
    default:
      return null;
  }
};

const categoryIdToAssessmentType = (catID) => {
  switch (parseInt(catID)) {
    case 1:
      return "Name the Letter";
    case 2:
      return "Letter Sounds";
    case 3:
      return "Story Reading";
    case 4:
      return "Silly Words";
    case 5:
      return "Break Up the Word";
    case 6:
      return "Say The First Sound";
    default:
      return null;
  }
};

const benchmarkMap = {
  1: "Fall",
  2: "Winter",
  3: "Spring",
};

const getExceptionRuleRow = (
  assessmentTypeLabel,
  gradeID,
  benchmarkID,
  isProgressMonitoring,
) => {
  const sheet = Boolean(isProgressMonitoring == 1)
    ? Array.isArray(exceptionRulesPM)
      ? exceptionRulesPM
      : exceptionRulesPM && exceptionRulesPM.ExceptionRulesPM
    : Array.isArray(exceptionRules)
      ? exceptionRules
      : exceptionRules && exceptionRules.ExceptionRules;

  if (!sheet || sheet.length === 0) return null;
  sheet.forEach((rule) => {
    rule["AboveBenchmark(Max)"] = Number(rule["AboveBenchmark(Min)"] || 0) + 50;
  });
  const levelLabel = ALL_LEVEL_OPTIONS.find(
    (option) => option.value == gradeID,
  );
  const gradeLabel = Boolean(isProgressMonitoring == 1)
    ? levelLabel?.label
    : gradeIdToLabel(gradeID);
  let benchmarkLabel;
  if (isProgressMonitoring == 1) {
    benchmarkLabel = benchmarkMap[3];
  } else {
    benchmarkLabel = benchmarkMap[Number(benchmarkID)];
  }

  if (benchmarkLabel === "Spring/AT") {
    benchmarkLabel = "Spring";
  }

  if (!assessmentTypeLabel || !gradeLabel || !benchmarkLabel) return null;

  // Determine whether to target row["Level"] or row["Grade"]
  const gradeKey = String(isProgressMonitoring) == "1" ? "Level" : "Grade";
  return (
    sheet.find((row) => {
      const at = (row["AssessmentType"] || "").toString();
      const gd = (row[gradeKey] || "").toString();
      const bm = (row["Benchmark"] || "").toString();
      return (
        at.toLowerCase().includes(assessmentTypeLabel.toLowerCase()) &&
        gd.toLowerCase() === gradeLabel.toLowerCase() &&
        (isProgressMonitoring
          ? true
          : bm.toLowerCase() === benchmarkLabel.toLowerCase())
      );
    }) || null
  );
};

const getExceptionValue = (row, headerLabel, fallback) => {
  if (!row) return fallback;
  if (
    Object.prototype.hasOwnProperty.call(row, headerLabel) &&
    row[headerLabel] !== null &&
    row[headerLabel] !== undefined
  )
    return row[headerLabel];
  return fallback;
};

const getAssessmentBenchmarkValue = (assessment, fieldName, fallback) => {
  if (!assessment || typeof assessment !== "object") return fallback;

  if (
    Object.prototype.hasOwnProperty.call(assessment, fieldName) &&
    assessment[fieldName] !== null &&
    assessment[fieldName] !== undefined
  ) {
    return assessment[fieldName];
  }

  const pascalFieldName = fieldName.replace(/^./, (char) => char.toUpperCase());

  if (
    Object.prototype.hasOwnProperty.call(assessment, pascalFieldName) &&
    assessment[pascalFieldName] !== null &&
    assessment[pascalFieldName] !== undefined
  ) {
    return assessment[pascalFieldName];
  }

  return fallback;
};

const getBenchmarkDefaults = (
  categoryID,
  gradeID,
  benchmarkId = 3,
  isProgressMonitoring,
  assessment,
) => {
  const primaryAssessmentLabel =
    categoryID === 3
      ? "Story Reading-TWC"
      : categoryID === 4
        ? "Silly Words-CLS"
        : categoryIdToAssessmentType(categoryID);
  const secondaryAssessmentLabel =
    categoryID === 3
      ? "Story Reading-%"
      : categoryID === 4
        ? "Silly Words-WWR"
        : categoryIdToAssessmentType(categoryID);

  const primaryRow = getExceptionRuleRow(
    primaryAssessmentLabel,
    gradeID,
    benchmarkId,
    isProgressMonitoring,
  );
  const secondaryRow = getExceptionRuleRow(
    secondaryAssessmentLabel,
    gradeID,
    benchmarkId,
    isProgressMonitoring,
  );
  const aboveBenchmarkMax =
    categoryID === 1 || categoryID === 2
      ? 110
      : categoryID === 3
        ? 100
        : categoryID === 4
          ? 150
          : categoryID === 5
            ? 80
            : categoryID === 6
              ? 70 //  60
              : 100;

  const hasAssessment = assessment !== null && assessment !== undefined;
  const isOriginalAssessment =
    hasAssessment &&
    Number(assessment.GradeID) === Number(gradeID) &&
    Number(assessment.BenchMarkID) === Number(benchmarkId);

  // If we match the original saved assessment, load its values.
  // If IDs changed or no assessment exists, calculate new defaults from exception rules.
  const useDefaults = !isOriginalAssessment;
  const benchmarkDefaults = {
    aboveBenchmarkMin: useDefaults
      ? getExceptionValue(primaryRow, "AboveBenchmark(Min)", 68)
      : getAssessmentBenchmarkValue(assessment, "aboveBenchmarkMin", 68),
    aboveBenchmarkMax: useDefaults
      ? getExceptionValue(primaryRow, "AboveBenchmark(Max)", aboveBenchmarkMax)
      : getAssessmentBenchmarkValue(
          assessment,
          "aboveBenchmarkMax",
          aboveBenchmarkMax,
        ),
    atBenchmarkMin: useDefaults
      ? getExceptionValue(primaryRow, "AtBenchmark(Min)", 52)
      : getAssessmentBenchmarkValue(assessment, "atBenchmarkMin", 52),
    atBenchmarkMax: useDefaults
      ? getExceptionValue(primaryRow, "AtBenchmark(Max)", 67)
      : getAssessmentBenchmarkValue(assessment, "atBenchmarkMax", 67),
    belowBenchmarkMin: useDefaults
      ? getExceptionValue(primaryRow, "BelowBenchmark(Min)", 37)
      : getAssessmentBenchmarkValue(assessment, "belowBenchmarkMin", 37),
    belowBenchmarkMax: useDefaults
      ? getExceptionValue(primaryRow, "BelowBenchmark(Max)", 51)
      : getAssessmentBenchmarkValue(assessment, "belowBenchmarkMax", 51),
    wellBelowBenchmarkMin: useDefaults
      ? getExceptionValue(primaryRow, "WellBelowBenchmark(Min)", 0)
      : getAssessmentBenchmarkValue(assessment, "wellBelowBenchmarkMin", 0),
    wellBelowBenchmarkMax: useDefaults
      ? getExceptionValue(primaryRow, "WellBelowBenchmark(Max)", 36)
      : getAssessmentBenchmarkValue(assessment, "wellBelowBenchmarkMax", 36),

    aboveBenchmarkMin1: useDefaults
      ? getExceptionValue(secondaryRow, "AboveBenchmark(Min)", 68)
      : getAssessmentBenchmarkValue(assessment, "aboveBenchmarkMin1", 68),
    aboveBenchmarkMax1: useDefaults
      ? getExceptionValue(
          secondaryRow,
          "AboveBenchmark(Max)",
          categoryID === 4 ? 50 : 100,
        )
      : getAssessmentBenchmarkValue(
          assessment,
          "aboveBenchmarkMax1",
          categoryID === 4 ? 50 : 100,
        ),
    atBenchmarkMin1: useDefaults
      ? getExceptionValue(secondaryRow, "AtBenchmark(Min)", 52)
      : getAssessmentBenchmarkValue(assessment, "atBenchmarkMin1", 52),
    atBenchmarkMax1: useDefaults
      ? getExceptionValue(secondaryRow, "AtBenchmark(Max)", 67)
      : getAssessmentBenchmarkValue(assessment, "atBenchmarkMax1", 67),
    belowBenchmarkMin1: useDefaults
      ? getExceptionValue(secondaryRow, "BelowBenchmark(Min)", 37)
      : getAssessmentBenchmarkValue(assessment, "belowBenchmarkMin1", 37),
    belowBenchmarkMax1: useDefaults
      ? getExceptionValue(secondaryRow, "BelowBenchmark(Max)", 51)
      : getAssessmentBenchmarkValue(assessment, "belowBenchmarkMax1", 51),
    wellBelowBenchmarkMin1: useDefaults
      ? getExceptionValue(secondaryRow, "WellBelowBenchmark(Min)", 0)
      : getAssessmentBenchmarkValue(assessment, "wellBelowBenchmarkMin1", 0),
    wellBelowBenchmarkMax1: useDefaults
      ? getExceptionValue(secondaryRow, "WellBelowBenchmark(Max)", 36)
      : getAssessmentBenchmarkValue(assessment, "wellBelowBenchmarkMax1", 36),
  };

  if (categoryID === 3 && Number(gradeID) === 7) {
    benchmarkDefaults.aboveBenchmarkMax = 0;
    benchmarkDefaults.aboveBenchmarkMax1 = 0;
  } else {
    benchmarkDefaults.aboveBenchmarkMax =
      Number(benchmarkDefaults.aboveBenchmarkMin) + 50;

    benchmarkDefaults.aboveBenchmarkMax1 =
      Number(benchmarkDefaults.aboveBenchmarkMin1) + 50;
  }
  return benchmarkDefaults;
};

const getInitialFormData = (assessment, user, location) => {
  const defaultCategoryID =
    assessment === null
      ? 1
      : assessment.CategoryID !== undefined
        ? assessment.CategoryID
        : 1;
  const defaultGradeID =
    assessment === null
      ? null
      : assessment.GradeID !== undefined
        ? assessment.GradeID
        : null;

  const benchmarkDefaults = getBenchmarkDefaults(
    assessment?.CategoryID,
    assessment?.GradeID,
    assessment?.BenchMarkID,
    assessment?.IsProgressMonitoring,
    assessment,
  );

  return {
    AssessmentID:
      assessment === null
        ? ""
        : assessment.AssessmentID !== undefined
          ? assessment.AssessmentID
          : "",
    BenchMarkID:
      assessment === null
        ? ""
        : assessment.BenchMarkID !== undefined
          ? assessment.BenchMarkID
          : "",
    CategoryID:
      assessment === null
        ? defaultCategoryID
        : assessment.CategoryID !== undefined
          ? assessment.CategoryID
          : defaultCategoryID,
    GradeID:
      assessment === null
        ? defaultGradeID
        : assessment.GradeID !== undefined
          ? assessment.GradeID
          : defaultGradeID,
    Title:
      assessment === null
        ? ""
        : assessment.Title !== undefined
          ? assessment.Title
          : "",
    Notes:
      assessment === null
        ? ""
        : assessment.Notes !== undefined
          ? assessment.Notes
          : "",
    Groups:
      assessment === null
        ? 1
        : assessment.Groups !== undefined
          ? assessment.Groups
          : 1,
    Timer:
      assessment === null
        ? 1
        : assessment.Timer !== undefined
          ? assessment.Timer
          : 1,
    ...benchmarkDefaults,
    instructionImg: null,
    imgFileName: null,
    Body: LoadBodyItems(assessment),
    SchoolsID: !location.pathname.includes("edit")
      ? user.SchoolID === null
        ? []
        : [user.SchoolID]
      : assessment === null
        ? []
        : assessment.SchoolIDs,
    bodyCount:
      assessment === null
        ? 0
        : assessment.bodyCount !== undefined
          ? assessment.bodyCount
          : 0,
    IsProgressMonitoring:
      assessment === null
        ? 0
        : assessment.IsProgressMonitoring !== undefined
          ? assessment.IsProgressMonitoring === true ||
            assessment.IsProgressMonitoring === 1
            ? 1
            : 0
          : 0,
    LevelID:
      assessment === null
        ? null
        : assessment.LevelID !== undefined
          ? assessment.LevelID
          : assessment.IsProgressMonitoring === true ||
              assessment.IsProgressMonitoring === 1
            ? 1
            : null,
    ProbeID:
      assessment === null
        ? null
        : assessment.ProbeID !== undefined
          ? assessment.ProbeID
          : assessment.IsProgressMonitoring === true ||
              assessment.IsProgressMonitoring === 1
            ? null
            : null,
  };
};

const AssessmentForm = ({
  assessment,
  addAssessment,
  importAssessments,
  updateAssessment,
  clearAssessment,
  clearResultList,
  user,
  schoolsList,
  assessmentsList,
  assessmentListLoading,
  deleteAssessment,
  deleteMultipleAssessments,
}) => {
  const hist = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const [deletionLoader, setDeletionLoader] = useState(false);
  const assessmentGroup = useSelector((state) => state.admin.assessmentGroup);
  const isEditMode = location.pathname.includes("edit");
  const isAddMode = location.pathname.includes("add");

  const isGroupMode =
    !isAddMode && Array.isArray(assessmentGroup) && assessmentGroup.length > 1;
  const instructionImg = useSelector(
    (state) => state.admin.assessmentInstruction,
  );
  const [formData, setFormData] = useState(() =>
    getInitialFormData(assessment, user, location),
  );
  const [fileName, setFileName] = useState();

  const onDrop = useCallback((acceptedFiles, event) => {
    if (acceptedFiles.length > 0) {
      setFileName(acceptedFiles[0].name);

      const reader = new FileReader();
      reader.onload = () => {
        setFormData((prevFormData) => ({
          ...prevFormData,
          instructionImg: reader.result,
          imgFileName: acceptedFiles[0].name,
        }));
      };
      reader.readAsDataURL(acceptedFiles[0]);
    }
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  const selectedAssessment = formData.CategoryID;
  const isStoryReadingSelected =
    selectedAssessment === 3 ||
    (Array.isArray(selectedAssessment) && selectedAssessment.includes(3));
  const isSillyWordSelected =
    selectedAssessment === 4 ||
    (Array.isArray(selectedAssessment) && selectedAssessment.includes(4));

  const isProgressMonitoringValue = (value) =>
    value === 1 || value === "1" || value === true;

  const getProgressMonitoringTitle = (categoryId, levelId) => {
    const assessmentType = categoryIdToAssessmentType(categoryId);
    return [
      assessmentType,
      levelId !== null && levelId !== undefined
        ? `Level ${levelId == 0 ? "K" : levelId}`
        : null,
    ]
      .filter(Boolean)
      .join("-");
  };

  // Dynamically filter levels based on selection
  const filteredLevelOptions = isStoryReadingSelected
    ? ALL_LEVEL_OPTIONS.slice(1, 9) // Dynamically grabs only Level 1 and Level 2
    : isSillyWordSelected
      ? ALL_LEVEL_OPTIONS.slice(0, 3) // Dynamically grabs only Level 1, Level 2, and Level 3
      : ALL_LEVEL_OPTIONS.slice(0, 2);

  useEffect(() => {
    if (!formData.CategoryID) return;

    // fetch instructions as before
    dispatch(getAssessmentInstructionByCategoryID(formData.CategoryID));

    // Determine allowed level options for the selected category (same slices used elsewhere)
    const isStory =
      formData.CategoryID === 3 ||
      (Array.isArray(formData.CategoryID) && formData.CategoryID.includes(3));
    const isSilly =
      formData.CategoryID === 4 ||
      (Array.isArray(formData.CategoryID) && formData.CategoryID.includes(4));

    const newFilteredLevelOptions = isStory
      ? ALL_LEVEL_OPTIONS.slice(1, 9)
      : isSilly
        ? ALL_LEVEL_OPTIONS.slice(0, 3)
        : ALL_LEVEL_OPTIONS.slice(0, 2);

    // If current LevelID is not in the allowed options, set it to the first available value
    if (newFilteredLevelOptions && newFilteredLevelOptions.length > 0) {
      const currentLevelValid = newFilteredLevelOptions.some(
        (opt) => String(opt.value) === String(formData.LevelID),
      );
      if (!currentLevelValid) {
        setFormData((prev) => ({
          ...prev,
          LevelID: newFilteredLevelOptions[0].value,
        }));
      }
    }
  }, [formData.CategoryID]);

  const [assessmentForms, setAssessmentForms] = useState(() => {
    if (isGroupMode) {
      return assessmentGroup
        .sort((a, b) => a.ProbeID - b.ProbeID)
        .map((item) => ({
          AssessmentID: item.AssessmentID, // <-- the piece that was missing
          title: item.Title,
          body: LoadBodyItems(item),
          bodyCount: item.bodyCount ?? 0,
          probeId: item.ProbeID,
        }));
    }
    return [{ title: "", body: "", bodyCount: 0, probeId: null }];
  });

  const [selectedProbeIds, setSelectedProbeIds] = useState(() => {
    if (isGroupMode) {
      return assessmentGroup
        .map((item) => item.ProbeID)
        .filter((id) => id != null);
    }
    return formData.ProbeID ? [formData.ProbeID] : [];
  });

  useEffect(() => {
    if (assessment !== null && !location.pathname.includes("edit")) return;

    const commonID = Boolean(IsProgressMonitoring == 1)
      ? formData.LevelID
      : formData.GradeID;
    const benchmarkDefaults = getBenchmarkDefaults(
      formData.CategoryID,
      commonID,
      formData.BenchMarkID,
      IsProgressMonitoring,
      assessment,
    );

    const shouldUpdate = Object.keys(benchmarkDefaults).some(
      (key) => formData[key] !== benchmarkDefaults[key],
    );

    if (shouldUpdate) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        ...benchmarkDefaults,
      }));
    }
  }, [
    assessment,
    formData.CategoryID,
    formData.GradeID,
    formData.LevelID,
    formData.BenchMarkID,
  ]);

  useEffect(() => {
    const isProgressMonitoring = isProgressMonitoringValue(
      formData?.IsProgressMonitoring,
    );
    const isEditMode = location.pathname.includes("edit");

    const benchmarkLabel = benchmarkMap[formData?.BenchMarkID];
    const assessmentType = categoryIdToAssessmentType(formData?.CategoryID);
    const gradeLabel = gradeIdToLabel(formData?.GradeID);

    if (formData?.CategoryID && (isProgressMonitoring || formData?.GradeID)) {
      // 1. Check if we are editing AND the dropdowns match the original saved assessment
      const hasAssessment = assessment !== null && assessment !== undefined;

      const isOriginalAssessment =
        isEditMode &&
        hasAssessment &&
        Number(assessment.CategoryID) === Number(formData?.CategoryID) &&
        Number(assessment.GradeID) === Number(formData?.GradeID) &&
        Number(assessment.BenchMarkID) === Number(formData?.BenchMarkID) &&
        Boolean(assessment.IsProgressMonitoring == "1") ===
          isProgressMonitoring;

      // 2. Construct Base Titles
      const progressMonitoringTitle = getProgressMonitoringTitle(
        formData?.CategoryID,
        LevelID,
      );

      const standardTitle = [benchmarkLabel, assessmentType, gradeLabel]
        .filter(Boolean)
        .join("-");

      const baseTitle = isProgressMonitoring
        ? progressMonitoringTitle
        : standardTitle;

      // 3. Update Main Form Title (only override if NOT on original saved assessment)
      setFormData((prev) => ({
        ...prev,
        Title:
          isOriginalAssessment && assessment?.Title
            ? assessment.Title
            : baseTitle,
      }));

      // 4. Determine Target Form Count
      let targetCount = 1;
      if (isProgressMonitoring) {
        targetCount = selectedProbeIds.length;
      } else if (Number(formData?.CategoryID) === 3) {
        targetCount = 3;
      }

      // 5. Update Assessment Forms Array
      setAssessmentForms((prev) => {
        const updatedForms = [];

        for (let i = 0; i < targetCount; i++) {
          const existingForm = prev[i] || {
            body: "",
            bodyCount: 0,
            probeId: null,
          };

          // const autoFormattedTitle = isProgressMonitoring
          //   ? `${baseTitle}-${selectedProbeIds[i]}`
          //   : `${baseTitle}-${i + 1}`;

          // Preserve saved title if editing original assessment AND existingForm has a title loaded from API
          const finalTitle =
            isOriginalAssessment && existingForm?.title
              ? existingForm.title
              : baseTitle;

          updatedForms.push({
            ...existingForm,
            title: finalTitle,
          });
        }

        return updatedForms;
      });
    }
  }, [
    formData?.BenchMarkID,
    formData?.CategoryID,
    formData?.GradeID,
    formData?.IsProgressMonitoring,
    formData?.LevelID,
    selectedProbeIds,
    location.pathname,
  ]);

  const onChange = (e, index) => {
    if (shouldUseMultipleBodies && index !== undefined) {
      if (e.target.id === "Body") {
        setAssessmentForms((prev) =>
          prev.map((item, i) =>
            i === index
              ? {
                  ...item,
                  body: e.target.value,
                  // If value is an array (Cat 5/6 structure), skip word-count string regex parsing
                  bodyCount: Array.isArray(e.target.value)
                    ? 0
                    : countWords(e.target.value),
                }
              : item,
          ),
        );
        return;
      }

      if (e.target.id === "Title") {
        setAssessmentForms((prev) =>
          prev.map((item, i) =>
            i === index ? { ...item, title: e.target.value } : item,
          ),
        );
        return;
      }
    }

    const newFormData = { ...formData, [e.target.id]: e.target.value };
    if (
      e.target.id === "CategoryID" ||
      e.target.id === "IsProgressMonitoring"
    ) {
      const nextCategoryID =
        e.target.id === "CategoryID"
          ? parseInt(e.target.value, 10)
          : parseInt(formData.CategoryID, 10);
      const nextIsPM =
        e.target.id === "IsProgressMonitoring"
          ? parseInt(e.target.value, 10)
          : parseInt(formData.IsProgressMonitoring, 10);

      if (nextCategoryID === 5 || nextCategoryID === 6) {
        // Categories 5 and 6 expect an array structure
        newFormData.Body = [];
        newFormData.bodyCount = 0;
      } else if (nextCategoryID === 3 || nextIsPM === 1) {
        // Multi-body forms use the separate assessmentForms state; clear the single Body
        newFormData.Body = "";
        newFormData.bodyCount = 0;
        // Reset the multiple bodies state to clean slate defaults
        setAssessmentForms([
          { title: "", body: "", bodyCount: 0, probeId: null },
        ]);
        setSelectedProbeIds([]);
      } else {
        // Standard text body categories (1, 2, 4) expect a string
        newFormData.Body = "";
        newFormData.bodyCount = 0;
      }
    }

    // If the max value of a benchmark changes, update the min value of the next benchmark

    // Testing logic for overriding range values
    // if(CategoryID !== 4){
    //   switch (e.target.id) {
    //     case "wellBelowBenchmarkMax":
    //       newFormData.belowBenchmarkMin = parseInt(e.target.value) + 1;
    //       break;
    //     case "wellBelowBenchmarkMax1":
    //       newFormData.belowBenchmarkMin1 = parseInt(e.target.value) + 1;
    //       break;
    //     case "belowBenchmarkMax":
    //       newFormData.atBenchmarkMin = parseInt(e.target.value) + 1;
    //       break;
    //     case "belowBenchmarkMax1":
    //       newFormData.atBenchmarkMin1 = parseInt(e.target.value) + 1;
    //       break;
    //     case "atBenchmarkMax":
    //       newFormData.aboveBenchmarkMin = parseInt(e.target.value) + 1;
    //       break;
    //     case "atBenchmarkMax1":
    //       newFormData.aboveBenchmarkMin1 = parseInt(e.target.value) + 1;
    //       break;
    //     case "Body":
    //       newFormData.bodyCount = countWords(e.target.value);
    //     default:
    //       break;
    //   }
    // }

    switch (e.target.id) {
      case "IsProgressMonitoring":
        if (parseInt(e.target.value) === 1) {
          newFormData.LevelID = 1;
          newFormData.ProbeID = null;
        }
        break;
      case "wellBelowBenchmarkMax":
        newFormData.belowBenchmarkMin = parseInt(e.target.value) + 1;
        break;
      case "wellBelowBenchmarkMax1":
        newFormData.belowBenchmarkMin1 = parseInt(e.target.value) + 1;
        break;
      case "belowBenchmarkMax":
        newFormData.atBenchmarkMin = parseInt(e.target.value) + 1;
        break;
      case "belowBenchmarkMax1":
        newFormData.atBenchmarkMin1 = parseInt(e.target.value) + 1;
        break;
      case "atBenchmarkMax":
        newFormData.aboveBenchmarkMin = parseInt(e.target.value) + 1;
        break;
      case "atBenchmarkMax1":
        newFormData.aboveBenchmarkMin1 = parseInt(e.target.value) + 1;
        break;
      case "Body":
        newFormData.bodyCount = countWords(e.target.value);
        break;
      default:
        break;
    }

    if (CategoryID === 4) {
      switch (e.target.id) {
        case "wellBelowBenchmarkMax":
          newFormData.belowBenchmarkMin = parseInt(e.target.value) + 1;
          break;
        case "belowBenchmarkMax":
          newFormData.atBenchmarkMin = parseInt(e.target.value) + 1;
          break;
        case "atBenchmarkMax":
          newFormData.aboveBenchmarkMin = parseInt(e.target.value) + 1;
          break;
        case "Body":
          newFormData.bodyCount = countWords(e.target.value);
          break;
        default:
          break;
      }
    }

    if (e.target.id === "IsProgressMonitoring" && e.target.value === "0") {
      newFormData.LevelID = null;
      newFormData.ProbeID = null;
    }

    const isKindergartenStoryReading =
      Number(newFormData.CategoryID) === 3 && Number(newFormData.GradeID) === 7;

    if (isKindergartenStoryReading) {
      newFormData.aboveBenchmarkMax = 0;
      newFormData.aboveBenchmarkMax1 = 0;
    } else {
      newFormData.aboveBenchmarkMax =
        Number(newFormData.aboveBenchmarkMin || 0) + 50;

      newFormData.aboveBenchmarkMax1 =
        Number(newFormData.aboveBenchmarkMin1 || 0) + 50;
    }

    setFormData(newFormData);
  };

  // Handle wrong input when completing a field input
  const onBlur = (e) => {
    if (CategoryID !== 4) {
      switch (e.target.id) {
        case "wellBelowBenchmarkMax":
          if (
            parseInt(e.target.value) < parseInt(formData.wellBelowBenchmarkMin)
          ) {
            alert("Max value cannot be less than Min value");
            e.target.value = "";
          }
          break;
        case "belowBenchmarkMax":
          if (parseInt(e.target.value) < parseInt(formData.belowBenchmarkMin)) {
            alert("Max value cannot be less than Min value");
            e.target.value = "";
          }
          break;
        case "atBenchmarkMax":
          if (parseInt(e.target.value) < parseInt(formData.atBenchmarkMin)) {
            alert("Max value cannot be less than Min value");
            e.target.value = "";
          }
          break;
        case "wellBelowBenchmarkMax1":
          if (
            parseInt(e.target.value) < parseInt(formData.wellBelowBenchmarkMin1)
          ) {
            alert("Max value cannot be less than Min value");
            e.target.value = "";
          }
          break;
        case "belowBenchmarkMax1":
          if (
            parseInt(e.target.value) < parseInt(formData.belowBenchmarkMin1)
          ) {
            alert("Max value cannot be less than Min value");
            e.target.value = "";
          }
          break;
        case "atBenchmarkMax1":
          if (parseInt(e.target.value) < parseInt(formData.atBenchmarkMin1)) {
            alert("Max value cannot be less than Min value");
            e.target.value = "";
          }
          break;
        default:
          break;
      }
    } else if (CategoryID === 4) {
      switch (e.target.id) {
        case "wellBelowBenchmarkMax":
          if (
            parseInt(e.target.value) < parseInt(formData.wellBelowBenchmarkMin)
          ) {
            alert("Max value cannot be less than Min value");
            e.target.value = "";
          }
          break;
        case "belowBenchmarkMax":
          if (parseInt(e.target.value) < parseInt(formData.belowBenchmarkMin)) {
            alert("Max value cannot be less than Min value");
            e.target.value = "";
          }
          break;
        case "atBenchmarkMax":
          if (parseInt(e.target.value) < parseInt(formData.atBenchmarkMin)) {
            alert("Max value cannot be less than Min value");
            e.target.value = "";
          }
          break;
        default:
          break;
      }
    }
  };

  const validateBenchmarkRanges = (data, categoryId) => {
    const checks = [
      [
        data.wellBelowBenchmarkMin,
        data.wellBelowBenchmarkMax,
        "Well Below Benchmark",
      ],
      [data.belowBenchmarkMin, data.belowBenchmarkMax, "Below Benchmark"],
      [data.atBenchmarkMin, data.atBenchmarkMax, "At Benchmark"],
      [data.aboveBenchmarkMin, data.aboveBenchmarkMax, "Above Benchmark"],
    ];

    if (categoryId === 3 || categoryId === 4) {
      checks.push(
        [
          data.wellBelowBenchmarkMin1,
          data.wellBelowBenchmarkMax1,
          "Well Below Benchmark 2",
        ],
        [data.belowBenchmarkMin1, data.belowBenchmarkMax1, "Below Benchmark 2"],
        [data.atBenchmarkMin1, data.atBenchmarkMax1, "At Benchmark 2"],
        [data.aboveBenchmarkMin1, data.aboveBenchmarkMax1, "Above Benchmark 2"],
      );
    }

    const invalidCheck = checks.find(([minValue, maxValue]) => {
      const min = parseInt(minValue, 10);
      const max = parseInt(maxValue, 10);
      return !Number.isNaN(min) && !Number.isNaN(max) && min > max;
    });

    if (invalidCheck) {
      const [, , label] = invalidCheck;
      dispatch(setAlert(`${label} has Min greater than Max`, "danger", 5000));
      // alert(`${label} has Min greater than Max`);
      return false;
    }

    return true;
  };

  // const onSubmit = (e) => {
  //   e.preventDefault();
  //   window.scrollTo(0, 0);

  //   if (!validateBenchmarkRanges(formData, CategoryID)) {
  //     return;
  //   }

  //   // If the assessment is not Silly word - Category 4 and Story Reading, no need the 2nd set of cutpoints
  //   if (CategoryID !== 3 && CategoryID !== 4) {
  //     delete formData.aboveBenchmarkMin1;
  //     delete formData.aboveBenchmarkMax1;
  //     delete formData.atBenchmarkMin1;
  //     delete formData.atBenchmarkMax1;
  //     delete formData.belowBenchmarkMin1;
  //     delete formData.belowBenchmarkMax1;
  //     delete formData.wellBelowBenchmarkMin1;
  //     delete formData.wellBelowBenchmarkMax1;
  //   }

  //   if (CategoryID === 3 || CategoryID === 4) {
  //     let HTMLText = Body.split(" ").join("&nbsp;");
  //     if (location.pathname.includes("edit")) {
  //       if (user.UserTypeID === 5) {
  //         updateAssessment(formData.AssessmentID, {
  //           ...formData,
  //           Body: HTMLText,
  //         });
  //       } else {
  //         deleteAssessment(formData.AssessmentID, assessment.CategoryID).then(
  //           () => {
  //             addAssessment({
  //               ...formData,
  //               Body: HTMLText,
  //               SchoolsID: [user.SchoolID],
  //             });
  //           },
  //         );
  //       }
  //     } else if (location.pathname.includes("add")) {
  //       //addAssessment({ ...formData, Body: HTMLText });
  //       importAssessments(payload);
  //     }
  //   } else if (CategoryID === 5) {
  //     let data = { ...formData };

  //     delete data.Groups;

  //     data.Solution = "";
  //     data.Scores = "";
  //     data.Body = "";
  //     for (let i = 0; i < formData.Body.length; i++) {
  //       if (i !== formData.Body.length - 1) {
  //         // Check if the word / solution having "" then do not add to the string
  //         if (
  //           formData.Body[i].Word === "" ||
  //           formData.Body[i].Solution === ""
  //         ) {
  //           continue;
  //         }
  //         data.Body += formData.Body[i].Word + ",";
  //         data.Solution += formData.Body[i].Solution + ",";
  //         data.Scores += formData.Body[i].Scores + ",";
  //       } else {
  //         if (
  //           formData.Body[i].Word === "" ||
  //           formData.Body[i].Solution === ""
  //         ) {
  //           continue;
  //         }
  //         data.Body += formData.Body[i].Word;
  //         data.Solution += formData.Body[i].Solution;
  //         data.Scores += formData.Body[i].Scores;
  //       }
  //     }
  //     if (location.pathname.includes("edit")) {
  //       if (user.UserTypeID === 5)
  //         updateAssessment(formData.AssessmentID, data);
  //       else {
  //         deleteAssessment(formData.AssessmentID, assessment.CategoryID).then(
  //           () => {
  //             addAssessment({ ...data, SchoolsID: [user.SchoolID] });
  //           },
  //         );
  //       }
  //     } else if (location.pathname.includes("add")) {
  //       addAssessment(data);
  //     }
  //   } else if (CategoryID === 6) {
  //     let data = { ...formData };
  //     delete data.Groups;

  //     data.Solution = "";
  //     data.Scores = "";
  //     data.SolutionDetails = "";
  //     data.Body = "";
  //     for (let i = 0; i < formData.Body.length; i++) {
  //       if (i !== formData.Body.length - 1) {
  //         data.Body += formData.Body[i].Word + ",";
  //         data.Solution += formData.Body[i].Solution + ",";
  //         data.Scores += formData.Body[i].Scores + ",";
  //         data.SolutionDetails += formData.Body[i].SolutionDetails + ",";
  //       } else {
  //         data.Body += formData.Body[i].Word;
  //         data.Solution += formData.Body[i].Solution;
  //         data.Scores += formData.Body[i].Scores;
  //         data.SolutionDetails += formData.Body[i].SolutionDetails;
  //       }
  //     }
  //     if (location.pathname.includes("edit")) {
  //       if (user.UserTypeID === 5)
  //         updateAssessment(formData.AssessmentID, data);
  //       else {
  //         deleteAssessment(formData.AssessmentID, assessment.CategoryID).then(
  //           () => {
  //             addAssessment({ ...data, SchoolsID: [user.SchoolID] });
  //           },
  //         );
  //       }
  //     } else if (location.pathname.includes("add")) {
  //       addAssessment(data);
  //     }
  //   } else {
  //     if (location.pathname.includes("edit")) {
  //       if (user.UserTypeID === 5)
  //         updateAssessment(formData.AssessmentID, formData);
  //       else {
  //         deleteAssessment(formData.AssessmentID, assessment.CategoryID).then(
  //           () => {
  //             addAssessment({ ...formData, SchoolsID: [user.SchoolID] });
  //           },
  //         );
  //       }
  //     } else if (location.pathname.includes("add")) {
  //       addAssessment(formData);
  //     }
  //   }
  //   console.log(formData);

  //   hist.push("/admin/assessments");
  //   clearAssessment();
  // };
  const [isSubmitted, setIsSubmitted] = useState(false);
  const onSubmit = (e) => {
    e.preventDefault();
    // window.scrollTo(0, 0);
    setIsSubmitted(true);

    // Validation check: ensure SchoolsID exists and has items
    const isPM = Boolean(formData?.IsProgressMonitoring == 1);

    const existingAssessments =
      isPM && !assessmentListLoading && assessmentsList?.length
        ? assessmentsList.filter(
            (assessment) =>
              assessment.CategoryID == formData.CategoryID &&
              assessment.LevelID == formData.LevelID &&
              formData?.SchoolsID.includes(assessment.SchoolID) &&
              selectedProbeIds?.includes(assessment.ProbeID),
          )
        : [];
    const existingProbes = existingAssessments.map((a) => a.ProbeID);
    if (
      isPM &&
      existingAssessments.length > 0 &&
      !location.pathname.includes("edit")
    ) {
      window.scrollTo(0, 0);
      // Already exists
      dispatch(
        setAlert(
          `The following probe(s) already exist: ${existingProbes.join(", ")}`,
          "danger",
          5000,
        ),
      );
      return;
    }

    const hasNoSchools = !formData?.SchoolsID?.length;

    // PM = true  --> Requires ProbeID
    // PM = false --> Requires BenchMarkID
    const missingRequiredAssessment = isPM
      ? formData?.ProbeID == null
      : !formData?.BenchMarkID;

    if (hasNoSchools || missingRequiredAssessment) {
      window.scrollTo(0, 0);
      return; // Stop form submission
    }

    // Proceed with your API call or submit logic here

    if (!validateBenchmarkRanges(formData, CategoryID)) {
      window.scrollTo(0, 0);
      return;
    }

    // If the assessment is not Silly word - Category 4 and Story Reading, no need the 2nd set of cutpoints
    if (CategoryID !== 3 && CategoryID !== 4) {
      delete formData.aboveBenchmarkMin1;
      delete formData.aboveBenchmarkMax1;
      delete formData.atBenchmarkMin1;
      delete formData.atBenchmarkMax1;
      delete formData.belowBenchmarkMin1;
      delete formData.belowBenchmarkMax1;
      delete formData.wellBelowBenchmarkMin1;
      delete formData.wellBelowBenchmarkMax1;
    }

    // Determine if this instance uses the multiple bodies structure
    const isEditingStructuredCategory =
      location.pathname.includes("edit") &&
      (CategoryID === 5 || CategoryID === 6);
    const isMultipleBody =
      (!Boolean(IsProgressMonitoring == 0) || CategoryID === 3) &&
      !isEditingStructuredCategory;
    if (isMultipleBody) {
      // --- MULTIPLE BODIES HANDLING FOR ALL CATEGORIES ---

      if (location.pathname.includes("edit")) {
        if (isGroupMode) {
          const updates = payload.map((item) => {
            const finalBody =
              typeof item.Body === "string"
                ? item.Body.split(" ").join("&nbsp;")
                : item.Body;
            return updateAssessment(item.AssessmentID, {
              ...item,
              Body: finalBody,
            });
          });

          Promise.all(updates).then(() => {
            hist.push("/admin/assessments");
            clearAssessment();
            dispatch(clearAssessmentGroup());
            clearResultList();
            dispatch(setAlert("Assessment updated Successfully", "success"));
          });
          return; // don't fall through to the shared hist.push at the bottom
        }

        // This block now safely only handles Categories 1 to 4 in edit mode
        let finalBodyPayload = (Body || "").split(" ").join("&nbsp;");

        if (user.UserTypeID === 5) {
          updateAssessment(formData.AssessmentID, {
            ...formData,
            Body: finalBodyPayload,
          }).then(() => {
            dispatch(setAlert("Assessment updated Successfully", "success"));
          });
        } else {
          deleteAssessment(formData.AssessmentID, assessment.CategoryID).then(
            () => {
              addAssessment({
                ...formData,
                Body: finalBodyPayload,
                SchoolsID: [user.SchoolID],
              });
            },
          );
        }
      } else if (location.pathname.includes("add")) {
        // Map over the payload items using the loop index to fetch data from the state array

        const formattedPayload = payload?.map((item, index) => {
          // Look up the matching entry in your assessmentForms state array
          const originalFormState = assessmentForms && assessmentForms[index];

          if (CategoryID === 5 || CategoryID === 6) {
            let updatedItem = { ...item };
            delete updatedItem.Groups;

            updatedItem.Solution = "";
            updatedItem.Scores = "";
            updatedItem.Body = "";

            if (CategoryID === 6) {
              updatedItem.SolutionDetails = "";
            }

            // Pull the array from state since item.Body is arriving from formData as an empty string
            const sourceBodyArray =
              originalFormState && Array.isArray(originalFormState.body)
                ? originalFormState.body
                : [];

            for (let i = 0; i < sourceBodyArray.length; i++) {
              const currentBody = sourceBodyArray[i];

              // Category 5 validation check: skip blank fields
              if (
                CategoryID === 5 &&
                ((currentBody.Word || "") === "" ||
                  (currentBody.Solution || "") === "")
              ) {
                continue;
              }

              const isLastElement = i === sourceBodyArray.length - 1;
              const separator = isLastElement ? "" : ",";

              updatedItem.Body += (currentBody.Word || "") + separator;
              updatedItem.Solution += (currentBody.Solution || "") + separator;
              updatedItem.Scores += (currentBody.Scores || "") + separator;

              if (CategoryID === 6) {
                updatedItem.SolutionDetails +=
                  (currentBody.SolutionDetails || "") + separator;
              }
            }

            // Sanitize trailing commas caused by skipped validation rows
            if (updatedItem.Body.endsWith(","))
              updatedItem.Body = updatedItem.Body.slice(0, -1);
            if (updatedItem.Solution.endsWith(","))
              updatedItem.Solution = updatedItem.Solution.slice(0, -1);
            if (updatedItem.Scores.endsWith(","))
              updatedItem.Scores = updatedItem.Scores.slice(0, -1);
            if (CategoryID === 6 && updatedItem.SolutionDetails.endsWith(",")) {
              updatedItem.SolutionDetails = updatedItem.SolutionDetails.slice(
                0,
                -1,
              );
            }

            return updatedItem;
          }

          // Default text transformation for categories 1, 2, 3, 4
          if (typeof item.Body === "string") {
            return {
              ...item,
              Body: item.Body.split(" ").join("&nbsp;"),
            };
          }

          return item;
        });

        importAssessments(formattedPayload);
      }
    } else if (CategoryID === 5) {
      // --- SINGLE BODY FOR CATEGORY 5 ---
      let data = { ...formData };
      delete data.Groups;

      data.Solution = "";
      data.Scores = "";
      data.Body = "";
      for (let i = 0; i < formData.Body.length; i++) {
        if (i !== formData.Body.length - 1) {
          if (
            formData.Body[i].Word === "" ||
            formData.Body[i].Solution === ""
          ) {
            continue;
          }
          data.Body += formData.Body[i].Word + ",";
          data.Solution += formData.Body[i].Solution + ",";
          data.Scores += formData.Body[i].Scores + ",";
        } else {
          if (
            formData.Body[i].Word === "" ||
            formData.Body[i].Solution === ""
          ) {
            continue;
          }
          data.Body += formData.Body[i].Word;
          data.Solution += formData.Body[i].Solution;
          data.Scores += formData.Body[i].Scores;
        }
      }
      if (location.pathname.includes("edit")) {
        if (user.UserTypeID === 5)
          updateAssessment(formData.AssessmentID, data).then(() => {
            dispatch(setAlert("Assessment updated Successfully", "success"));
          });
        else {
          deleteAssessment(formData.AssessmentID, assessment.CategoryID).then(
            () => {
              addAssessment({ ...data, SchoolsID: [user.SchoolID] });
            },
          );
        }
      } else if (location.pathname.includes("add")) {
        addAssessment(data);
      }
    } else if (CategoryID === 6) {
      // --- SINGLE BODY FOR CATEGORY 6 ---
      let data = { ...formData };
      delete data.Groups;

      data.Solution = "";
      data.Scores = "";
      data.SolutionDetails = "";
      data.Body = "";
      for (let i = 0; i < formData.Body.length; i++) {
        if (i !== formData.Body.length - 1) {
          data.Body += formData.Body[i].Word + ",";
          data.Solution += formData.Body[i].Solution + ",";
          data.Scores += formData.Body[i].Scores + ",";
          data.SolutionDetails += formData.Body[i].SolutionDetails + ",";
        } else {
          data.Body += formData.Body[i].Word;
          data.Solution += formData.Body[i].Solution;
          data.Scores += formData.Body[i].Scores;
          data.SolutionDetails += formData.Body[i].SolutionDetails;
        }
      }
      if (location.pathname.includes("edit")) {
        if (user.UserTypeID === 5)
          updateAssessment(formData.AssessmentID, data).then(() => {
            dispatch(setAlert("Assessment updated Successfully", "success"));
          });
        else {
          deleteAssessment(formData.AssessmentID, assessment.CategoryID).then(
            () => {
              addAssessment({ ...data, SchoolsID: [user.SchoolID] });
            },
          );
        }
      } else if (location.pathname.includes("add")) {
        addAssessment(data);
      }
    } else {
      // --- SINGLE BODY FOR ALL OTHER CATEGORIES (1, 2, 4, etc.) ---
      if (location.pathname.includes("edit")) {
        if (user.UserTypeID === 5)
          updateAssessment(formData.AssessmentID, formData).then(() => {
            dispatch(setAlert("Assessment updated Successfully", "success"));
          });
        else {
          deleteAssessment(formData.AssessmentID, assessment.CategoryID).then(
            () => {
              addAssessment({ ...formData, SchoolsID: [user.SchoolID] });
            },
          );
        }
      } else if (location.pathname.includes("add")) {
        addAssessment(formData);
      }
    }

    hist.push("/admin/assessments");
    clearAssessment();
    clearResultList();
    // loadAssessmentsList({ SchoolIDs: [assessment?.SchoolID] });
  };
  const {
    GradeID,
    CategoryID,
    Title,
    Notes,
    Timer,
    aboveBenchmarkMin,
    aboveBenchmarkMax,
    atBenchmarkMin,
    atBenchmarkMax,
    belowBenchmarkMin,
    belowBenchmarkMax,
    wellBelowBenchmarkMin,
    wellBelowBenchmarkMax,
    aboveBenchmarkMin1,
    aboveBenchmarkMax1,
    atBenchmarkMin1,
    atBenchmarkMax1,
    belowBenchmarkMin1,
    belowBenchmarkMax1,
    wellBelowBenchmarkMin1,
    wellBelowBenchmarkMax1,
    Body,
    Groups,
    IsProgressMonitoring,
    LevelID,
    ProbeID,
  } = formData;

  const shouldUseMultipleBodies = CategoryID === 3 || IsProgressMonitoring == 1;
  const showMultipleBodyTitles = CategoryID === 3 && IsProgressMonitoring == 0;

  useEffect(() => {
    return () => {
      dispatch(clearAssessmentGroup());
    };
  }, []);
  useEffect(() => {
    if (!shouldUseMultipleBodies) return;

    let count = 1;

    if (IsProgressMonitoring == 1) {
      count = selectedProbeIds.length || 0;
    } else if (CategoryID === 3) {
      count = 3;
    }

    const progressMonitoringTitle = getProgressMonitoringTitle(
      CategoryID,
      LevelID,
    );
    const standardTitle = [
      benchmarkMap[formData?.BenchMarkID],
      categoryIdToAssessmentType(CategoryID),
      gradeIdToLabel(GradeID),
    ]
      .filter(Boolean)
      .join("-");
    const baseTitle =
      IsProgressMonitoring == 1 ? progressMonitoringTitle : standardTitle;

    setAssessmentForms((prev) => {
      return Array.from({ length: count }, (_, i) => ({
        AssessmentID: prev[i]?.AssessmentID,
        title: prev[i]?.title || baseTitle,
        body: prev[i]?.body || "",
        bodyCount: prev[i]?.bodyCount || 0,
        probeId: IsProgressMonitoring == 1 ? selectedProbeIds[i] : null,
      }));
    });
    // Ensure the shared top Title reflects the baseTitle for PM or standard forms
    setFormData((prev) => ({
      ...prev,
      Title: prev.Title && prev.Title !== "" ? prev.Title : baseTitle,
    }));
  }, [
    shouldUseMultipleBodies,
    IsProgressMonitoring,
    selectedProbeIds,
    CategoryID,
  ]);

  // Keep the main Title consistently populated for progress monitoring
  // whenever probe selection, level, or category changes. This prevents
  // the title from being cleared when multiple probes are selected.
  useEffect(() => {
    if (!isProgressMonitoringValue(formData?.IsProgressMonitoring)) return;

    const pmTitle = getProgressMonitoringTitle(
      formData?.CategoryID,
      formData?.LevelID,
    );

    setFormData((prev) => ({
      ...prev,
      Title: pmTitle,
    }));
  }, [
    selectedProbeIds,
    formData?.CategoryID,
    formData?.LevelID,
    formData?.IsProgressMonitoring,
  ]);

  const payload = shouldUseMultipleBodies
    ? assessmentForms.map((item) => ({
        ...formData,
        AssessmentID: item.AssessmentID ?? formData.AssessmentID,
        Title: item.title,
        Body:
          typeof item.body === "string"
            ? item.body.split("&nbsp;").join(" ")
            : item.body,
        bodyCount: item.bodyCount,
        ProbeID: item.probeId,
      }))
    : formData;

  if (schoolsList.length === 0 && !location.pathname.includes("edit"))
    return <Redirect to="/admin/assessments" />;

  if (assessment === null && location.pathname.includes("edit"))
    return <Redirect to="/admin/assessments" />;
  return (
    <div className="p-sm-5 p-2 w-100  dashboard-margin mx-lg-auto container">
      <div className="mb-3 ">
        <h6 className="txt-primary-light">
          {user.UserType} / Library / Assessment
        </h6>

        <div className="d-sm-flex  w-100 align-items-center justify-content-between">
          <div className="d-flex mb-2 mb-sm-0">
            <div
              className="admin-back mx-2 rounded-circle d-flex align-items-center justify-content-center txt-primary"
              onClick={() => {
                hist.goBack();
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                fill="currentColor"
                className="bi bi-arrow-left-short"
                viewBox="0 0 16 16"
              >
                <path
                  fillRule="evenodd"
                  d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"
                />
              </svg>
            </div>
            <h4 className="m-0">
              {location.pathname.includes("add") ? "Create Assessment" : "Edit"}
            </h4>
          </div>
        </div>
      </div>
      <Alert />
      <form onSubmit={(e) => onSubmit(e)}>
        <div className="card w-100 p-2 p-sm-3 p-lg-4 shadow-lg border-0 mb-2">
          <h6 className="m-0">Class Information</h6>
          <div className="w-100 g-3 overflow-hidden">
            <div className="w-100 row g-2 my-2">
              <div className="col-md-3">
                <label htmlFor="Title">
                  <b>Title</b>
                </label>
                <input
                  type="text"
                  className="form-control border-primary"
                  id="Title"
                  value={Title || ""}
                  onChange={(e) => onChange(e)}
                  disabled={assessment?.CategoryID != 3 ? true : false}
                />
              </div>
              <div className="col-md-3">
                <label htmlFor="Notes">
                  <b>Notes</b>
                </label>
                <textarea
                  className="form-control border-primary"
                  id="Notes"
                  value={Notes || ""}
                  onChange={onChange}
                  rows="3"
                  placeholder="Add notes for this assessment"
                />
              </div>
            </div>
            <div className="w-100 row g-2 my-2">
              <div className="col-auto">
                <label htmlFor="IsProgressMonitoring">
                  <b>Is it a progress monitoring assessment?</b>
                </label>
                <select
                  className="form-select form-control border-primary"
                  aria-label="Default select example"
                  value={IsProgressMonitoring}
                  id="IsProgressMonitoring"
                  disabled={location.pathname.includes("edit") ? true : false}
                  onChange={(e) => onChange(e)}
                >
                  <option value={0}>No</option>
                  <option value={1}>Yes</option>
                </select>
              </div>
            </div>

            {/* 2nd row - Grade selection */}
            <div className="w-100 row g-2 my-2">
              {IsProgressMonitoring == 0 && (
                <>
                  <div className="col-auto">
                    <label htmlFor="inputGrade">
                      <b>Grade</b>
                    </label>
                    <select
                      className="form-select form-control border-primary"
                      aria-label="Default select example"
                      value={GradeID || ""}
                      id="GradeID"
                      onChange={(e) => onChange(e)}
                    >
                      <option value="" disabled hidden>
                        Select Grade
                      </option>
                      <option value={7}>Kindergarten</option>
                      <option value={1}>Grade 1</option>
                      <option value={2}>Grade 2</option>
                      <option value={3}>Grade 3</option>
                      <option value={4}>Grade 4</option>
                      <option value={5}>Grade 5</option>
                      <option value={6}>Grade 6</option>
                      <option value={8}>Grade 7</option>
                      <option value={9}>Grade 8</option>
                      <option value={10}>Other</option>
                    </select>
                  </div>
                  {/* Benchmark */}

                  <div
                    className={`col-auto ${
                      isSubmitted &&
                      (!formData?.BenchMarkID || formData?.BenchMarkID === "")
                        ? "is-invalid"
                        : ""
                    }`}
                  >
                    <label for="inputAssessment">
                      <b>Benchmark</b>
                    </label>
                    <MultiSelectWithCheckboxes
                      // disabled={
                      //   location.pathname.includes("edit") ? true : false
                      // }
                      required={
                        !formData?.BenchMarkID || formData.BenchMarkID === ""
                      }
                      id="BenchMarkID"
                      value={formData?.BenchMarkID || ""}
                      optionsList={[
                        {
                          value: "",
                          label: "Please Select a Benchmark",
                        },
                        { value: 1, label: "Benchmark – Fall" },
                        { value: 2, label: "Benchmark – Winter" },
                        { value: 3, label: "Benchmark – Spring" },
                        // { value: 4, label: "Progress Monitoring" },
                      ]}
                      placeholder={"Select a Benchmark"}
                      formData={formData}
                      setFormData={setFormData}
                      isMulti={false}
                      showSelectAll={false}
                    />
                    {/* Error Validation Message */}
                    {isSubmitted &&
                      (!formData?.BenchMarkID ||
                        formData.BenchMarkID === "") && (
                        <div className="invalid-feedback d-block">
                          Please select a benchmark.
                        </div>
                      )}
                  </div>
                </>
              )}
              <div className="col-auto">
                <label htmlFor="Timer">
                  <b>Timer (Mins)</b>
                </label>
                <input
                  type="number"
                  class="form-control border-primary "
                  id="Timer"
                  step="1"
                  min="0"
                  value={Timer}
                  required
                  onChange={(e) => onChange(e)}
                />
              </div>
              {CategoryID < 5 && (
                <div className="col-auto">
                  <label htmlFor="Groups">
                    <b>Groups</b>
                  </label>
                  <input
                    type="number"
                    class="form-control border-primary"
                    id="Groups"
                    step="1"
                    min="0"
                    required
                    value={CategoryID === 3 ? 1 : Groups}
                    readOnly={CategoryID === 3}
                    onChange={(e) => onChange(e)}
                  />
                </div>
              )}
            </div>

            {/* 3rd row - Populated attributes of PM or Schools */}

            <div className="w-100 row g-2 my-2">
              {IsProgressMonitoring == 1 && (
                <>
                  {/* Level */}
                  <div className="col-2">
                    <label htmlFor="LevelID">
                      <b>Level</b>
                    </label>
                    <select
                      className="form-select form-control border-primary"
                      aria-label="Default select example"
                      value={LevelID}
                      id="LevelID"
                      disabled={
                        location.pathname.includes("edit") ? true : false
                      }
                      onChange={(e) => onChange(e)}
                    >
                      {filteredLevelOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Probe  */}

                  <div className="col-3">
                    <div
                      className={
                        isSubmitted && formData.ProbeID === null
                          ? "is-invalid"
                          : ""
                      }
                    >
                      <label htmlFor="ProbeID">
                        <b>Probe</b>
                      </label>
                      {/* <select
                      className="form-select form-control border-primary"
                      aria-label="Default select example"
                      value={ProbeID}
                      id="ProbeID"
                      disabled={
                        location.pathname.includes("edit") ? true : false
                      }
                      onChange={(e) => onChange(e)}
                    >
                      <option value={1}>Probe 1</option>
                      <option value={2}>Probe 2</option>
                      <option value={3}>Probe 3</option>
                      <option value={4}>Probe 4</option>
                      <option value={5}>Probe 5</option>
                      <option value={6}>Probe 6</option>
                      <option value={7}>Probe 7</option>
                      <option value={8}>Probe 8</option>
                      <option value={9}>Probe 9</option>
                      <option value={10}>Probe 10</option>
                      <option value={11}>Probe 11</option>
                      <option value={12}>Probe 12</option>
                      <option value={13}>Probe 13</option>
                      <option value={14}>Probe 14</option>
                      <option value={15}>Probe 15</option>
                      <option value={16}>Probe 16</option>
                      <option value={17}>Probe 17</option>
                      <option value={18}>Probe 18</option>
                      <option value={19}>Probe 19</option>
                      <option value={20}>Probe 20</option>
                    </select> */}
                      <MultiSelectWithCheckboxes
                        disabled={
                          location.pathname.includes("edit") ? true : false
                        }
                        id="ProbeID"
                        value={selectedProbeIds}
                        optionsList={probeOptions}
                        placeholder={"Select Probe(s)"}
                        formData={formData}
                        setFormData={setFormData}
                        isMulti={true}
                        showSelectAll={true}
                        onChange={(values) => {
                          setSelectedProbeIds(values);

                          // keep existing single ProbeID field
                          setFormData((prev) => ({
                            ...prev,
                            ProbeID: values[0] || null,
                            Title: getProgressMonitoringTitle(
                              prev.CategoryID,
                              prev.LevelID,
                            ),
                          }));
                        }}
                      />

                      {isSubmitted && formData.ProbeID === null && (
                        <div className="invalid-feedback d-block">
                          Please select at least one Probe.
                        </div>
                      )}
                    </div>
                  </div>
                </>
              )}
            </div>
            {/* Schools */}
            <div
              className={
                isSubmitted &&
                (!formData.SchoolsID || formData.SchoolsID.length === 0)
                  ? "is-invalid"
                  : ""
              }
            >
              <div className="col-8">
                {user?.UserTypeID === 5 &&
                  Array.isArray(schoolsList) &&
                  schoolsList.length > 0 &&
                  !location?.pathname?.includes("edit") && (
                    <>
                      <label htmlFor="SchoolsID">
                        <b>School</b>
                      </label>

                      <MultiSelectWithCheckboxes
                        id="SchoolsID"
                        value={formData?.SchoolsID || []}
                        optionsList={schoolsList
                          .slice()
                          .sort((a, b) =>
                            (a?.Name || "").localeCompare(b?.Name || ""),
                          )
                          .map((school) => ({
                            value: school.SchoolID,
                            label: school.Name,
                          }))}
                        placeholder="Select School(s)"
                        formData={formData}
                        setFormData={setFormData}
                        isMulti={true}
                        showSelectAll={true}
                      />

                      {/* Error Validation Message */}
                      {isSubmitted &&
                        (!formData?.SchoolsID ||
                          formData.SchoolsID.length === 0) && (
                          <div className="invalid-feedback d-block">
                            Please select at least one school.
                          </div>
                        )}
                    </>
                  )}
              </div>
            </div>
          </div>
        </div>
        <AssessmentFormTypes
          formData={formData}
          setFormData={setFormData}
          edit={location.pathname.includes("edit")}
        />
        <div className="card w-100 p-2 p-sm-3 p-lg-4 shadow-lg border-0 mb-2">
          <h6 className="m-0">Benchmark Status Setting</h6>
          <div className="w-100 g-3 overflow-hidden">
            {/* Cut-point Original */}
            <div className="w-100 row g-4 my-2">
              <div className="col-3 m-0">
                <label htmlFor="wellBelow">
                  <b>Well Below Benchmark</b>
                </label>
                <div className="d-flex gap-2">
                  <div className="d-flex flex-column w-50">
                    {/* <div>Min</div> */}
                    {CategoryID === 4 ? (
                      <div className="border-bottom">CLS</div>
                    ) : CategoryID === 3 ? (
                      <div className="border-bottom">Total Word Correct</div>
                    ) : (
                      <div className="border-bottom">Cutpoint</div>
                    )}
                    <input
                      hidden
                      type="number"
                      class="form-control border-primary "
                      id="wellBelowBenchmarkMin"
                      step="1"
                      min="0"
                      onKeyDown={(e) =>
                        ["e", "E", "+", "-"].includes(e.key) &&
                        e.preventDefault()
                      }
                      value={wellBelowBenchmarkMin}
                      readOnly={true}
                      onChange={(e) => onChange(e)}
                    />
                  </div>
                  <div className="d-flex flex-column w-50">
                    <div>Max</div>
                    <input
                      type="number"
                      class="form-control border-primary "
                      id="wellBelowBenchmarkMax"
                      step="1"
                      min={
                        wellBelowBenchmarkMax === 0
                          ? wellBelowBenchmarkMax
                          : "1"
                      }
                      onKeyDown={(e) =>
                        ["e", "E", "+", "-"].includes(e.key) &&
                        e.preventDefault()
                      }
                      value={wellBelowBenchmarkMax}
                      required
                      onChange={(e) => onChange(e)}
                      onBlur={(e) => onBlur(e)}
                    />
                  </div>
                </div>
              </div>
              <div className="col-3 m-0">
                <label htmlFor="belowBenchmark">
                  <b>Below Benchmark</b>
                </label>
                <div className="d-flex gap-2">
                  <div className="d-flex flex-column">
                    <div>Min</div>
                    <input
                      width="10px"
                      type="number"
                      class="form-control border-primary "
                      id="belowBenchmarkMin"
                      step="1"
                      min="0"
                      onKeyDown={(e) =>
                        ["e", "E", "+", "-"].includes(e.key) &&
                        e.preventDefault()
                      }
                      value={belowBenchmarkMin}
                      required
                      readOnly={true}
                      onChange={(e) => onChange(e)}
                    />
                  </div>
                  <div className="d-flex flex-column">
                    <div>Max</div>
                    <input
                      type="number"
                      class="form-control border-primary "
                      id="belowBenchmarkMax"
                      step="1"
                      min="0"
                      onKeyDown={(e) =>
                        ["e", "E", "+", "-"].includes(e.key) &&
                        e.preventDefault()
                      }
                      value={belowBenchmarkMax}
                      required
                      onChange={(e) => onChange(e)}
                      onBlur={(e) => onBlur(e)}
                    />
                  </div>
                </div>
              </div>
              <div className="col-3 m-0">
                <label htmlFor="atBenchmark">
                  <b>At Benckmark</b>
                </label>
                <div className="d-flex gap-2">
                  <div className="d-flex flex-column">
                    <div>Min</div>
                    <input
                      type="number"
                      class="form-control border-primary "
                      id="atBenchmarkMin"
                      step="1"
                      min="0"
                      onKeyDown={(e) =>
                        ["e", "E", "+", "-"].includes(e.key) &&
                        e.preventDefault()
                      }
                      value={atBenchmarkMin}
                      required
                      readOnly={true}
                      onChange={(e) => onChange(e)}
                    />
                  </div>
                  <div className="d-flex flex-column">
                    <div>Max</div>
                    <input
                      type="number"
                      class="form-control border-primary "
                      id="atBenchmarkMax"
                      step="1"
                      min="0"
                      onKeyDown={(e) =>
                        ["e", "E", "+", "-"].includes(e.key) &&
                        e.preventDefault()
                      }
                      value={atBenchmarkMax}
                      required
                      onChange={(e) => onChange(e)}
                      onBlur={(e) => onBlur(e)}
                    />
                  </div>
                </div>
              </div>
              <div className="col-3 m-0">
                <label htmlFor="AboveBenchmark">
                  <b>Above Benchmark</b>
                </label>
                <div className="d-flex gap-2">
                  <div className="d-flex flex-column w-50">
                    <div>Min</div>
                    <input
                      width="10px"
                      type="number"
                      className="form-control border-primary "
                      id="aboveBenchmarkMin"
                      step="1"
                      min="0"
                      onKeyDown={(e) =>
                        ["e", "E", "+", "-"].includes(e.key) &&
                        e.preventDefault()
                      }
                      value={aboveBenchmarkMin}
                      required
                      readOnly={true}
                      onChange={(e) => onChange(e)}
                    />
                  </div>
                  <div className="d-flex flex-column w-50">
                    {/* <div>Max</div> */}
                    <input
                      hidden
                      type="number"
                      class="form-control border-primary "
                      id="aboveBenchmarkMax"
                      step="1"
                      min="0"
                      onKeyDown={(e) =>
                        ["e", "E", "+", "-"].includes(e.key) &&
                        e.preventDefault()
                      }
                      value={aboveBenchmarkMax}
                      onChange={(e) => onChange(e)}
                      onBlur={(e) => onBlur(e)}
                    />
                  </div>
                </div>
              </div>
            </div>
            {/* Cut-point Silly Words */}
            {CategoryID === 4 && (
              <div className="w-100 row g-4 my-2">
                <div className="col-3 m-0">
                  <label htmlFor="wellBelow">
                    <b>Well Below Benchmark</b>
                  </label>
                  <div className="d-flex gap-2">
                    <div className="d-flex flex-column w-50">
                      {/* <div>Min</div> */}
                      {CategoryID === 4 ? (
                        <div className="border-bottom">CWR</div>
                      ) : (
                        <div className="border-bottom">Cutpoint</div>
                      )}
                      <input
                        hidden
                        width="10px"
                        type="number"
                        class="form-control border-primary "
                        id="wellBelowBenchmarkMin1"
                        step="1"
                        min="0"
                        onKeyDown={(e) =>
                          ["e", "E", "+", "-"].includes(e.key) &&
                          e.preventDefault()
                        }
                        value={wellBelowBenchmarkMin1}
                        readOnly={true}
                        onChange={(e) => onChange(e)}
                      />
                    </div>
                    <div className="d-flex flex-column w-50">
                      <div>Max</div>
                      <input
                        type="number"
                        class="form-control border-primary "
                        id="wellBelowBenchmarkMax1"
                        step="1"
                        min={0}
                        onKeyDown={(e) =>
                          ["e", "E", "+", "-"].includes(e.key) &&
                          e.preventDefault()
                        }
                        value={wellBelowBenchmarkMax1}
                        required
                        onChange={(e) => onChange(e)}
                        onBlur={(e) => onBlur(e)}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-3 m-0">
                  <label htmlFor="belowBenchmark1">
                    <b>Below Benchmark</b>
                  </label>
                  <div className="d-flex gap-2">
                    <div className="d-flex flex-column">
                      <div>Min</div>
                      <input
                        width="10px"
                        type="number"
                        class="form-control border-primary "
                        id="belowBenchmarkMin1"
                        step="1"
                        min={0}
                        onKeyDown={(e) =>
                          ["e", "E", "+", "-"].includes(e.key) &&
                          e.preventDefault()
                        }
                        value={belowBenchmarkMin1}
                        required
                        onChange={(e) => onChange(e)}
                      />
                    </div>
                    <div className="d-flex flex-column">
                      <div>Max</div>
                      <input
                        type="number"
                        class="form-control border-primary "
                        id="belowBenchmarkMax1"
                        step="1"
                        min={0}
                        onKeyDown={(e) =>
                          ["e", "E", "+", "-"].includes(e.key) &&
                          e.preventDefault()
                        }
                        value={belowBenchmarkMax1}
                        required
                        onChange={(e) => onChange(e)}
                        onBlur={(e) => onBlur(e)}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-3 m-0">
                  <label htmlFor="atBenchmark1">
                    <b>At Benchmark</b>
                  </label>
                  <div className="d-flex gap-2">
                    <div className="d-flex flex-column">
                      <div>Min</div>
                      <input
                        type="number"
                        class="form-control border-primary "
                        id="atBenchmarkMin1"
                        step="1"
                        min="0"
                        onKeyDown={(e) =>
                          ["e", "E", "+", "-"].includes(e.key) &&
                          e.preventDefault()
                        }
                        value={atBenchmarkMin1}
                        required
                        onChange={(e) => onChange(e)}
                      />
                    </div>
                    <div className="d-flex flex-column">
                      <div>Max</div>
                      <input
                        type="number"
                        class="form-control border-primary "
                        id="atBenchmarkMax1"
                        step="1"
                        min="0"
                        onKeyDown={(e) =>
                          ["e", "E", "+", "-"].includes(e.key) &&
                          e.preventDefault()
                        }
                        value={atBenchmarkMax1}
                        required
                        onChange={(e) => onChange(e)}
                        onBlur={(e) => onBlur(e)}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-3 m-0">
                  <label htmlFor="AboveBenchmark1">
                    <b>Above Benchmark</b>
                  </label>
                  <div className="d-flex gap-2">
                    <div className="d-flex flex-column w-50">
                      <div>Min</div>
                      <input
                        width="10px"
                        type="number"
                        className="form-control border-primary "
                        id="aboveBenchmarkMin1"
                        step="1"
                        min="0"
                        onKeyDown={(e) =>
                          ["e", "E", "+", "-"].includes(e.key) &&
                          e.preventDefault()
                        }
                        value={aboveBenchmarkMin1}
                        required
                        // readOnly={true}
                        onChange={(e) => onChange(e)}
                      />
                    </div>
                    <div className="d-flex flex-column">
                      {/* <div>Max</div> */}
                      <input
                        hidden
                        type="number"
                        class="form-control border-primary w-50"
                        id="aboveBenchmarkMax1"
                        step="1"
                        min="0"
                        onKeyDown={(e) =>
                          ["e", "E", "+", "-"].includes(e.key) &&
                          e.preventDefault()
                        }
                        value={aboveBenchmarkMax1}
                        onChange={(e) => onChange(e)}
                        onBlur={(e) => onBlur(e)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Cut-point Story Reading */}
            {CategoryID === 3 && (
              <div className="w-100 row g-4 my-2">
                <div className="col-3 m-0">
                  <label htmlFor="wellBelow">
                    <b>Well Below Benchmark</b>
                  </label>
                  <div className="d-flex gap-2">
                    <div className="d-flex flex-column w-50">
                      {/* <div>Min</div> */}
                      {CategoryID === 3 ? (
                        <div className="border-bottom">Accuracy %</div>
                      ) : (
                        <div className="border-bottom">Cutpoint</div>
                      )}
                      <input
                        hidden
                        width="10px"
                        type="number"
                        class="form-control border-primary "
                        id="wellBelowBenchmarkMin1"
                        step="1"
                        min="0"
                        onKeyDown={(e) =>
                          ["e", "E", "+", "-"].includes(e.key) &&
                          e.preventDefault()
                        }
                        value={wellBelowBenchmarkMin1}
                        readOnly={true}
                        onChange={(e) => onChange(e)}
                      />
                    </div>
                    <div className="d-flex flex-column w-50">
                      <div>Max</div>
                      <input
                        type="number"
                        class="form-control border-primary "
                        id="wellBelowBenchmarkMax1"
                        step="1"
                        min="0"
                        onKeyDown={(e) =>
                          ["e", "E", "+", "-"].includes(e.key) &&
                          e.preventDefault()
                        }
                        value={wellBelowBenchmarkMax1}
                        required
                        onChange={(e) => onChange(e)}
                        onBlur={(e) => onBlur(e)}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-3 m-0">
                  <label htmlFor="belowBenchmark1">
                    <b>Below Benchmark</b>
                  </label>
                  <div className="d-flex gap-2">
                    <div className="d-flex flex-column">
                      <div>Min</div>
                      <input
                        width="10px"
                        type="number"
                        class="form-control border-primary "
                        id="belowBenchmarkMin1"
                        step="1"
                        min="0"
                        onKeyDown={(e) =>
                          ["e", "E", "+", "-"].includes(e.key) &&
                          e.preventDefault()
                        }
                        value={belowBenchmarkMin1}
                        required
                        readOnly={true}
                        onChange={(e) => onChange(e)}
                      />
                    </div>
                    <div className="d-flex flex-column">
                      <div>Max</div>
                      <input
                        type="number"
                        class="form-control border-primary "
                        id="belowBenchmarkMax1"
                        step="1"
                        min="0"
                        onKeyDown={(e) =>
                          ["e", "E", "+", "-"].includes(e.key) &&
                          e.preventDefault()
                        }
                        value={belowBenchmarkMax1}
                        required
                        onChange={(e) => onChange(e)}
                        onBlur={(e) => onBlur(e)}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-3 m-0">
                  <label htmlFor="atBenchmark1">
                    <b>At Benchmark</b>
                  </label>
                  <div className="d-flex gap-2">
                    <div className="d-flex flex-column">
                      <div>Min</div>
                      <input
                        type="number"
                        class="form-control border-primary "
                        id="atBenchmarkMin1"
                        step="1"
                        min="0"
                        onKeyDown={(e) =>
                          ["e", "E", "+", "-"].includes(e.key) &&
                          e.preventDefault()
                        }
                        value={atBenchmarkMin1}
                        required
                        readOnly={true}
                        onChange={(e) => onChange(e)}
                      />
                    </div>
                    <div className="d-flex flex-column">
                      <div>Max</div>
                      <input
                        type="number"
                        class="form-control border-primary "
                        id="atBenchmarkMax1"
                        step="1"
                        min="0"
                        onKeyDown={(e) =>
                          ["e", "E", "+", "-"].includes(e.key) &&
                          e.preventDefault()
                        }
                        value={atBenchmarkMax1}
                        required
                        onChange={(e) => onChange(e)}
                        onBlur={(e) => onBlur(e)}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-3 m-0">
                  <label htmlFor="AboveBenchmark1">
                    <b>Above Benchmark</b>
                  </label>
                  <div className="d-flex gap-2">
                    <div className="d-flex flex-column w-50">
                      <div>Min</div>
                      <input
                        width="10px"
                        type="number"
                        className="form-control border-primary "
                        id="aboveBenchmarkMin1"
                        step="1"
                        min="0"
                        onKeyDown={(e) =>
                          ["e", "E", "+", "-"].includes(e.key) &&
                          e.preventDefault()
                        }
                        value={aboveBenchmarkMin1}
                        required
                        readOnly={true}
                        onChange={(e) => onChange(e)}
                      />
                    </div>
                    <div className="d-flex flex-column">
                      {/* <div>Max</div> */}
                      <input
                        hidden
                        type="number"
                        class="form-control border-primary w-50"
                        id="aboveBenchmarkMax1"
                        step="1"
                        min="0"
                        onKeyDown={(e) =>
                          ["e", "E", "+", "-"].includes(e.key) &&
                          e.preventDefault()
                        }
                        value={aboveBenchmarkMax1}
                        required
                        onChange={(e) => onChange(e)}
                        onBlur={(e) => onBlur(e)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="card w-100 p-2 p-sm-3 p-lg-4 shadow-lg border-0 mb-2">
          {true && (
            <div class="accordion shadow border-0" id="directions">
              <div class="accordion-item border-0">
                <h2 class="accordion-header" id="headingOne">
                  <button
                    class="accordion-button focus-primary"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                  >
                    Directions
                  </button>
                </h2>
                <div
                  id="collapseOne"
                  class="accordion-collapse collapse "
                  aria-labelledby="headingOne"
                  data-bs-parent="#directions"
                >
                  <div class="accordion-body text-center">
                    {/* Upload Image Area */}
                    <div className="d-flex justify-content-end">
                      <div
                        className="w-100 p-3 border border-primary rounded "
                        {...getRootProps({
                          onClick: (event) => console.log(event),
                          role: "button",
                          "aria-label": "drag and drop area",
                        })}
                      >
                        <input {...getInputProps()} />
                        <div className="d-flex flex-column align-items-center gap-2">
                          <div className="bg-light-green rounded-circle flex-shrink-0 text-center d-flex align-items-center justify-content-center admin-assessments-type">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              width="60px"
                              fill="none"
                            >
                              <path
                                stroke="white"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M19 2v3m0 3V5m0 0h3m-3 0h-3"
                              />
                              <path
                                fill="white"
                                fill-rule="evenodd"
                                d="M13 2H5a3 3 0 0 0-3 3v10.5c0 .086.011.17.032.25A1 1 0 0 0 2 16v3a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-7a1 1 0 0 0-.032-.25A1 1 0 0 0 22 11.5V11h-2v.016c-4.297.139-7.4 1.174-9.58 2.623.826.293 1.75.71 2.656 1.256 1.399.84 2.821 2.02 3.778 3.583a1 1 0 1 1-1.706 1.044c-.736-1.203-1.878-2.178-3.102-2.913-1.222-.734-2.465-1.192-3.327-1.392a15.466 15.466 0 0 0-3.703-.386h-.022c-.348.005-.68.02-.994.045V5a1 1 0 0 1 1-1h8V2zM8.5 6a2.68 2.68 0 0 0-1.522.488C6.408 6.898 6 7.574 6 8.5c0 .926.408 1.601.978 2.011A2.674 2.674 0 0 0 8.5 11c.41 0 1.003-.115 1.522-.489.57-.41.978-1.085.978-2.011 0-.926-.408-1.601-.978-2.012A2.674 2.674 0 0 0 8.5 6z"
                                clip-rule="evenodd"
                              />
                            </svg>
                          </div>
                          {fileName ? (
                            <>
                              <div>{fileName}</div>
                            </>
                          ) : (
                            <>
                              {isDragActive ? (
                                <div>Drop the image here ...</div>
                              ) : (
                                <div>
                                  Drag and drop instruction here, or click to
                                  select image
                                </div>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                    <img
                      //src={process.env.PUBLIC_URL + `/images/${CategoryID}.png`} // Old logic: Use static img from public folder cant dynamically change
                      src={instructionImg || ""}
                      alt=""
                      srcSet=""
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="card w-100 p-2 p-sm-3 p-lg-4 shadow-lg border-0  mb-2 ">
          {/* {formData.CategoryID === 3 ? (
            Array.from({ length: 3 }).map((_, i) => (
              <AssessmentFormBody
                key={i}
                index={i}
                formData={formData}
                setFormData={setFormData}
                onChange={onChange}
              />
            ))
          ) : (
            <AssessmentFormBody
              formData={formData}
              setFormData={setFormData}
              onChange={onChange}
            />
          )} */}
          <div className="card w-100 p-2 p-sm-3 p-lg-4 shadow-lg border-0 mb-2">
            {shouldUseMultipleBodies && (!isEditMode || isGroupMode) ? (
              assessmentForms.map((item, i) => (
                <div key={i} className="mb-4">
                  {showMultipleBodyTitles && (
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <label htmlFor="Title" className="form-label">
                          <b>Title</b>
                        </label>

                        <input
                          type="text"
                          required
                          className="form-control border-primary"
                          placeholder="Please enter a title"
                          id="Title"
                          value={item.title}
                          onChange={(e) => onChange(e, i)}
                        />
                      </div>
                    </div>
                  )}

                  <AssessmentFormBody
                    mode={
                      location.pathname.includes("edit") ? "edit" : "create"
                    }
                    index={i}
                    formData={{
                      ...formData,
                      title: item.title,
                      Body: item.body, // Pass to uppercase variant so initialization reads it cleanly
                      body: item.body,
                      bodyCount: item.bodyCount,
                    }}
                    setFormData={setFormData}
                    onChange={(e) => onChange(e, i)}
                    selectedProbeIds={selectedProbeIds}
                  />
                </div>
              ))
            ) : (
              <>
                <AssessmentFormBody
                  mode={location.pathname.includes("edit") ? "edit" : "create"}
                  formData={formData}
                  setFormData={setFormData}
                  onChange={onChange}
                />
              </>
            )}
          </div>
          <div className="d-flex align-items-center justify-content-end mb-2 gap-2 p-2">
            <button type="submit" className="button-primary btn-block btn px-5">
              Save
            </button>

            {/* Delete Button */}
            {/* Delete Modal */}
            {user.UserTypeID === 5 && assessment && (
              <>
                <div
                  className="modal fade"
                  id="deleteassessment"
                  aria-labelledby="deleteassessmentLabel"
                  aria-hidden="true"
                >
                  <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title" id="deleteassessmentLabel">
                          Delete Assessment
                        </h5>
                        <button
                          type="button"
                          className="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        ></button>
                      </div>
                      <div className="modal-body">
                        Are you sure you want to delete this assessment?
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-secondary"
                          data-bs-dismiss="modal"
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          className="btn button-primary"
                          onClick={() => {
                            setDeletionLoader(true);
                            if (isGroupMode) {
                              const groupPayload = assessmentGroup.map(
                                (item) => ({
                                  AssessmentID: item.AssessmentID,
                                  SchoolID: item.SchoolID,
                                  CategoryID: item.CategoryID,
                                }),
                              );

                              deleteMultipleAssessments(groupPayload).then(
                                () => {
                                  hist.push("/admin/assessments");
                                  clearAssessment();
                                  dispatch(clearAssessmentGroup());
                                  clearResultList();
                                  setDeletionLoader(false);
                                },
                              );
                            } else {
                              deleteAssessment(
                                formData.AssessmentID,
                                assessment.CategoryID,
                              ).then(() => {
                                hist.push("/admin/assessments");
                                clearAssessment();
                                clearResultList();
                                setDeletionLoader(false);
                              });
                            }
                          }}
                          data-bs-dismiss="modal"
                        >
                          Confirm
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="btn btn-danger d-flex align-items-center px-4 mx-3"
                  data-bs-toggle="modal"
                  data-bs-target="#deleteassessment"
                  aria-disabled={deletionLoader}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-trash-fill button-child"
                    viewBox="0 0 16 16"
                  >
                    <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z" />
                  </svg>
                  {deletionLoader ? (
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    />
                  ) : (
                    <>Delete</>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </form>
    </div>
  );
};

AssessmentForm.propTypes = {
  assessment: PropTypes.object,
  addAssessment: PropTypes.func.isRequired,
  importAssessments: PropTypes.func.isRequired,
  updateAssessment: PropTypes.func.isRequired,
  clearAssessment: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  schoolsList: PropTypes.array.isRequired,
  deleteAssessment: PropTypes.func.isRequired,
  clearResultList: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => ({
  assessment: state.admin.assessment,
  user: state.auth.user,
  schoolsList: state.admin.schoolsList,
  assessmentsList: state.admin.assessmentsList,
  assessmentListLoading: state.admin.assessmentListLoading,
});
export default connect(mapStateToProps, {
  addAssessment,
  importAssessments,
  updateAssessment,
  clearAssessment,
  deleteAssessment,
  deleteMultipleAssessments,
  clearResultList,
})(AssessmentForm);
